import { useMemo } from 'react';
import { comics, type Comic } from '@/mocks/comics';
import ComicCard from './ComicCard';
import SectionHeader from './SectionHeader';

interface FeaturedProps {
  searchTerm: string;
  onSelect: (comic: Comic) => void;
}

export default function Featured({ searchTerm, onSelect }: FeaturedProps) {
  const keyword = searchTerm.trim();

  const filtered = useMemo(() => {
    if (!keyword) return comics;
    return comics.filter((c) =>
      [c.title, c.author, c.category, ...c.tags].some((t) => t.includes(keyword)),
    );
  }, [keyword]);

  return (
    <section id="featured" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionHeader
          kicker="热门推荐"
          title={keyword ? `“${keyword}” 的搜索结果` : '编辑精选 · 高分口碑佳作'}
          desc={
            keyword
              ? `为你找到 ${filtered.length} 部相关作品`
              : '经编辑部与千万读者共同票选出的高分韩漫，题材横跨恋爱、奇幻、校园与悬疑，每一部都值得收藏。'
          }
        />

        {filtered.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {filtered.map((comic) => (
              <ComicCard key={comic.id} comic={comic} onSelect={onSelect} />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-16 text-center">
            <span className="w-16 h-16 flex items-center justify-center rounded-full bg-background-200 text-foreground-400">
              <i className="ri-search-line text-2xl w-6 h-6 flex items-center justify-center" />
            </span>
            <p className="mt-4 font-semibold text-foreground-900">没有找到相关作品</p>
            <p className="mt-1 text-sm text-foreground-500">换个关键词试试，或浏览下方的题材分类</p>
            <button
              type="button"
              onClick={() => {
                document.getElementById('categories')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="mt-5 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 cursor-pointer"
            >
              浏览全部分类
            </button>
          </div>
        )}
      </div>
    </section>
  );
}